import styleInject from './node_modules-style-inject-dist-style-inject.es.js';

var css_248z = "";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=src-components-ConversationEvent-ConversationEvent.styles.scss.js.map
